
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { BriefingItemContainer } from "@/model/BriefingItemContainer";

    @Component({ })
    export default class BriefingMatrixMenu extends Vue {

        @Prop({ required: true }) item!: BriefingItemContainer;

        get questionTypeText(): string { return this.item?.isQuiz ? "Test" : "Briefing" ; }

    }
